<!-- 订单产品毛利表 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="客户：">
            <el-select filterable v-model="searchForm.TC_ID" placeholder="请选择客户" clearable>
              <el-option v-for="item in tcCustomerList" :key="item.ID" :label="item.AB_NAME" :value="item.ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select filterable v-model="searchForm.PROJECT_ID" placeholder="请选择项目点" clearable>
              <el-option v-for="item in projectList" :key="item.value" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker unlink-panels v-model="searchForm.DATE_RANGE" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" />
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input v-model="searchForm.PRODUCT_CODE" placeholder="请输入产品编码" />
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.PRODUCT_NAME" placeholder="请输入产品名称" />
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input v-model="searchForm.SALE_ORDER_ID" placeholder="请输入订单ID" clearable />
          </el-form-item>
          <el-form-item>
            <tooltip-button button-type="primary" @click="fliterData" button-text="筛选" :tip-content="禁用原因"
              :disabled="!禁用原因" />
            <download-json-to-excel ref="download" :header="header" fileName="订单产品毛利表.xlsx" type="primary" plain
              @click="exportForm" text="导出" :tip-content="禁用原因" :disabled="!禁用原因" />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
          <el-table-column label="产品名称" prop="PRODUCT_NAME" min-width="100px"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="100px"></el-table-column>
          <el-table-column label="一级大类" prop="FC_NAME" min-width="100px"></el-table-column>
          <el-table-column label="发货单价" prop="DELIVER_PRICE" min-width="100px"></el-table-column>
          <el-table-column label="发货金额" prop="DELIVER_FEE" min-width="100px"></el-table-column>
          <el-table-column label="发货毛利" prop="DELIVER_GROSS_PROFIT" min-width="100px"></el-table-column>
          <el-table-column label="订购数量" prop="SALE_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="实际发货数量" prop="DELIVER_COUNT" min-width="110px"></el-table-column>
          <el-table-column label="销售单价" prop="SALE_PRICE" min-width="100px"></el-table-column>
          <el-table-column label="销售收入" prop="SALE_FEE" min-width="100px"></el-table-column>
          <el-table-column label="销售毛利" prop="SALE_GROSS_FEE" min-width="100px"></el-table-column>
          <el-table-column label="客户名称" prop="TC_NAME" min-width="100px"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME" min-width="100px"></el-table-column>
          <el-table-column label="档口" prop="DK_NAME" min-width="100px"></el-table-column>
          <el-table-column label="供应商名称" prop="SUPPLIER_NAME" min-width="100px"></el-table-column>
          <el-table-column label="日期" prop="SEND_DAY" min-width="100px"></el-table-column>
          <el-table-column label="订单ID" prop="SALE_ORDER_ID" min-width="100px"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="queryData" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { haveDSXMDFun, 获取订单产品毛利表数据 } from 'api/sellOrder';
import http from '@/assets/common/http';
import date from '@/assets/common/date';
import validation from '@/assets/common/validation';

export default {
  data () {
    return {
      searchForm: {
        DATE_RANGE: [date(new Date() - 30 * 24 * 60 * 60 * 1000, '%F'), date(new Date(), '%F')],
      },
      tableData: [],
      tcCustomerList: [],
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      //   项目点
      projectList: [],
      header: {
        PRODUCT_CODE: '产品编码',
        PRODUCT_NAME: '产品名称',
        SHORT_NAME: '短名称',
        BRAND: '品牌',
        SPECIFICATION: '规格',
        TYPE_UNIT: '单位',
        FC_NAME: '一级大类',
        DELIVER_PRICE: '发货单价',
        DELIVER_FEE: '发货金额',
        DELIVER_GROSS_PROFIT: '发货毛利',
        SALE_COUNT: '订购数量',
        DELIVER_COUNT: '实际发货数量',
        SALE_PRICE: '销售单价',
        SALE_FEE: '销售收入',
        SALE_GROSS_FEE: '销售毛利',
        TC_NAME: '客户名称',
        PROJECT_NAME: '项目点',
        DK_NAME: '档口',
        SUPPLIER_NAME: '供应商名称',
        SEND_DAY: '日期',
        SALE_ORDER_ID: '订单ID',
      },
    };
  },
  computed: {
    禁用原因 () {
      if (!validation.日期范围验证(this.searchForm.DATE_RANGE, 30)) {
        return '请选择31天内日期范围';
      }
      if (!validation.产品编码验证(this.searchForm.PRODUCT_CODE)) {
        return '请输入正确的产品编码';
      }
      if (this.searchForm.SALE_ORDER_ID && !validation.订单ID验证(this.searchForm.SALE_ORDER_ID)) {
        return '请输入正确的订单ID';
      }
      return '';
    },
    订单产品毛利表筛选记忆 () {
      return this.$store.state.订单产品毛利表筛选记忆;
    },
  },
  created () {
    if (Object.keys(this.订单产品毛利表筛选记忆).length) {
      this.searchForm = this.订单产品毛利表筛选记忆.CONDITION;
      this.currentPage = this.订单产品毛利表筛选记忆.CURRENT_PAGE;
    }
    this.queryData();
    this.queryTcCustomer();
    this.queryProject();
  },
  methods: {
    // 拉取项目点
    queryProject () {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 3,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.projectList = result[0].project;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取团餐公司
    queryTcCustomer () {
      haveDSXMDFun().then((result) => {
        this.tcCustomerList = result.length > 0 ? result[0].company : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出
    exportForm () {
      const params = {};
      for (const key in this.searchForm) {
        if (key == 'DATE_RANGE') {
          if (this.searchForm[key] && this.searchForm[key].length) {
            [params.START_DAY, params.END_DAY] = this.searchForm[key];
          }
        } else {
          if (this.searchForm[key]) {
            params[key] = this.searchForm[key];
          }
        }
      }
      获取订单产品毛利表数据(params).then((result) => {
        if (result.length && result[0].ORDER_LIST && result[0].ORDER_LIST.length) {
          this.$store.dispatch('保存订单产品毛利表筛选记忆', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
          this.$refs.download.download(
            result[0].ORDER_LIST.map(({
              PRODUCT_CODE, PRODUCT_NAME, SHORT_NAME, BRAND, SPECIFICATION, TYPE_UNIT, FC_NAME, DELIVER_COUNT, DELIVER_PRICE, SUPPLIER_NAME,
              DELIVER_FEE, DELIVER_GROSS_PROFIT, SALE_COUNT, SALE_PRICE, SALE_FEE, SALE_GROSS_FEE, TC_NAME, PROJECT_NAME, DK_NAME, SEND_DAY, SALE_ORDER_ID,
            }) => ({
              PRODUCT_CODE: String(PRODUCT_CODE),
              PRODUCT_NAME,
              SHORT_NAME,
              BRAND,
              SPECIFICATION,
              TYPE_UNIT,
              FC_NAME,
              DELIVER_COUNT,
              DELIVER_PRICE,
              DELIVER_FEE,
              DELIVER_GROSS_PROFIT,
              SALE_COUNT,
              SALE_PRICE,
              SALE_FEE,
              SALE_GROSS_FEE,
              TC_NAME,
              PROJECT_NAME,
              DK_NAME,
              SUPPLIER_NAME,
              SEND_DAY,
              SALE_ORDER_ID,
            })),
            [16, 40, 40, 10, 10, 4, 20, 10, 10, 10, 10, 15, 10, 10, 10, 35, 30, 20, 35, 10, 8],
          );
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    fliterData () {
      this.currentPage = 1;
      this.queryData();
    },
    // 获取界面数据
    queryData () {
      const params = {
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
      };
      for (const key in this.searchForm) {
        if (key == 'DATE_RANGE') {
          if (this.searchForm[key] && this.searchForm[key].length) {
            [params.START_DAY, params.END_DAY] = this.searchForm[key];
          }
        } else {
          if (this.searchForm[key]) {
            params[key] = this.searchForm[key];
          }
        }
      }
      获取订单产品毛利表数据(params).then((result) => {
        if (result.length) {
          this.tableData = result[0].ORDER_LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          if (this.tableData.length) {
            this.$store.dispatch('保存订单产品毛利表筛选记忆', {
              CONDITION: this.searchForm,
              CURRENT_PAGE: this.currentPage,
            });
          }
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/tableManage/orderProductGrossProfitTable.vue